/**
 * TD Complete the Swap — horizontal product carousel (matches TD video story behavior).
 */
(function () {
  const TAG = 'td-complete-swap-slider';
  if (customElements.get(TAG)) return;

  const MOBILE_MQL = window.matchMedia('(max-width: 749px)');
  const TABLET_MQL = window.matchMedia('(max-width: 989px)');

  class TdCompleteSwapSlider extends HTMLElement {
    constructor() {
      super();
      this.track = null;
      this.slides = [];
      this.prevBtn = null;
      this.nextBtn = null;
      this.currentIndex = 0;
      this.maxIndex = 0;
      this.gap = 16;
    }

    connectedCallback() {
      this.track = this.querySelector('[data-td-swap-track]');
      this.slides = [...this.querySelectorAll('[data-td-swap-slide]')];
      const root = this.closest('.td-swap-slider-wrap');
      this.prevBtn = root?.querySelector('[data-td-swap-prev]');
      this.nextBtn = root?.querySelector('[data-td-swap-next]');

      this.prevBtn?.addEventListener('click', () => this.goTo(this.currentIndex - 1));
      this.nextBtn?.addEventListener('click', () => this.goTo(this.currentIndex + 1));
      window.addEventListener('resize', () => this.onLayoutChange());
      requestAnimationFrame(() => this.onLayoutChange());
    }

    getVisibleCount() {
      if (MOBILE_MQL.matches) return 1.05;
      if (TABLET_MQL.matches) return 2.5;
      return 4;
    }

    getPerViewFloor() {
      return Math.max(1, Math.floor(this.getVisibleCount()));
    }

    onLayoutChange() {
      const root = this.closest('.td-complete-swap');
      const gap = parseInt(getComputedStyle(root).getPropertyValue('--td-swap-gap'), 10) || 16;
      this.gap = gap;
      this.maxIndex = Math.max(0, this.slides.length - this.getPerViewFloor());
      if (this.currentIndex > this.maxIndex) this.currentIndex = this.maxIndex;
      this.updateSlideMetrics();
      this.updateArrowVisibility();
      this.updateArrowDisabled();
      this.updatePosition();
    }

    updateSlideMetrics() {
      const sliderWidth = this.clientWidth;
      if (!sliderWidth) return;
      const visible = this.getVisibleCount();
      const gapCount = Math.max(0, Math.ceil(visible) - 1);
      const slideW = (sliderWidth - this.gap * gapCount) / visible;
      const root = this.closest('.td-complete-swap');
      root?.style.setProperty('--td-swap-slide-basis', Math.max(0, slideW) + 'px');
    }

    updateArrowVisibility() {
      const hide = this.slides.length <= this.getPerViewFloor();
      [this.prevBtn, this.nextBtn].forEach((btn) => {
        if (!btn) return;
        btn.classList.toggle('is-hidden', hide);
        if (hide) btn.disabled = true;
      });
    }

    updateArrowDisabled() {
      if (this.slides.length <= this.getPerViewFloor()) return;
      if (this.prevBtn) {
        const atStart = this.currentIndex <= 0;
        this.prevBtn.disabled = atStart;
        this.prevBtn.classList.toggle('is-disabled', atStart);
        this.prevBtn.setAttribute('aria-disabled', atStart ? 'true' : 'false');
      }
      if (this.nextBtn) {
        const atEnd = this.currentIndex >= this.maxIndex;
        this.nextBtn.disabled = atEnd;
        this.nextBtn.classList.toggle('is-disabled', atEnd);
        this.nextBtn.setAttribute('aria-disabled', atEnd ? 'true' : 'false');
      }
    }

    getSlideStep() {
      const slide = this.slides[0];
      return slide ? slide.offsetWidth + this.gap : 0;
    }

    goTo(index) {
      if (this.slides.length <= this.getPerViewFloor()) return;
      this.currentIndex = Math.max(0, Math.min(this.maxIndex, index));
      this.updatePosition();
      this.updateArrowDisabled();
    }

    updatePosition() {
      if (!this.track || !this.slides.length) return;
      const offset = this.getSlideStep() * this.currentIndex;
      this.track.style.transform = 'translateX(-' + offset + 'px)';
    }
  }

  customElements.define(TAG, TdCompleteSwapSlider);
})();
